import { defineStore } from 'pinia';

export const agenciaStoreModule = defineStore('agenciaStore', {
  state: () => ({
    nombre: null,
    email: null,
    currencySymbol: null,
    locale: 'es',
    telefono: null,
    buscadorForfaitEnabled: true,
    buscadorEnabled: null,
    recursos: {
      avisosLegales: null,
      imagenFondo: null,
    },
    termsConditions: null,
  }),
  getters: {
    getCurrency(state) {
      return state.currencySymbol;
    },
    getCurrencyName(state) {
      return state.currencyName;
    },
    getTelefono(state) {
      return state.telefono;
    },
    getImagenFondo(state) {
      return state.recursos.imagenFondo;
    },
    getTermsConditions(state) {
      return state.termsConditions;
    },
  },
  actions: {
    setData(hAgenciaDto) {
      this.nombre = hAgenciaDto.nombre;
      this.email = hAgenciaDto.email;
      this.currencySymbol = hAgenciaDto.currencySymbol;
      this.currencyName = hAgenciaDto.currencyName;
      this.locale = hAgenciaDto.locale;
      this.telefono = hAgenciaDto.telefono;
      this.buscadorForfaitEnabled = hAgenciaDto.buscadorForfaitEnabled;
      this.buscadorEnabled = hAgenciaDto.buscadorEnabled;
      this.recursos.imagenFondo = hAgenciaDto.recursos.img_mis_reservas_fondo;
      this.termsConditions = hAgenciaDto.termsConditions;
    },
  },
});
